import { ElasticManager } from '@dtsl/jsutils/dist/elasticWrapper';

export function initElasticRUM(authToken: string, id: number) {
  const elasticInitialiseData = {
    serviceName: 'video-calls',
    serverUrl: import.meta.env.VITE_APM_SERVICE_URL as string,
    environment: import.meta.env.MODE,
    serviceVersion: '',
  };
  const userContext = { id: id };
  const customContext = { session: authToken };
  ElasticManager.methodInitiator('init', [elasticInitialiseData]);
  ElasticManager.methodInitiator('setUserContext', [userContext]);
  ElasticManager.methodInitiator('setCustomContext', [customContext]);
}
